import JobZImage from "../jobz-img";
import { NavLink } from "react-router-dom";
import { publicUser, candidate, canRoute } from "../../../globals/route-names";
import { useEffect, useState } from "react";
// import { empRoute, employer } from "../../../globals/route-names";
import axiosInstance from '../../../axiosInstance';
import { API_URL } from "../../../config";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../../../LanguageSelector";

const colors = [
  "#E63946", // red
  "#457B9D", // blue-gray
  "#2A9D8F", // teal
  "#F4A261", // orange
  "#264653", // deep teal
  "#8E44AD", // purple
  "#D7263D", // crimson
  "#3A86FF", // vivid blue
  "#06D6A0", // mint green
  "#FFBE0B", // yellow
  "#8338EC", // violet
  "#FF006E", // pink
  "#118AB2", // bright blue
  "#073B4C", // dark navy
  "#F77F00", // deep orange
  "#38B000", // green
  "#7209B7", // purple
  "#FF7F50", // coral
  "#008080", // classic teal
];

function getRandomColor(seed) {
    const index = seed.charCodeAt(0) % colors.length;
    return colors[index];
}


function Header1({ _config }) {
    const { t } = useTranslation();
    const [menuActive, setMenuActive] = useState(false);
    const [user, setUser] = useState(null);
    const [imgError, setImgError] = useState(false);

    useEffect(() => {
        console.log("useEffect running");
        const authToken = localStorage.getItem('authToken');
        console.log("authToken from localStorage:", authToken);

        if (authToken !== null) {
            let isMounted = true;
            const fetchProfile = async () => {
                try {
                    const response = await axiosInstance.get(`${API_URL}/candidate-profile`);
                    console.log("API response:", response.data);
                    if (isMounted) {
                        setUser(response.data.data);
                    }
                } catch (error) {
                    if (isMounted) {
                        console.error("Error fetching profile:", error.response?.data || error.message);
                    }
                }
            };
            fetchProfile();
            return () => {
                isMounted = false;
            };
        } else {
            console.log("No authToken found in localStorage");
        }
    }, []);

    function handleNavigationClick() {
        setMenuActive(!menuActive);
    }

    const getInitials = () => {
        if (!user || !user.first_name || !user.last_name) return "";
        return `${user.first_name[0]}`.toUpperCase();
    };

    const getAvatarColor = () => {
        if (!user || !user.first_name) return colors[0];
        return getRandomColor(user.first_name[0].toUpperCase());
    };

    return (
        <>
            <header className={"site-header " + _config.style + " mobile-sider-drawer-menu " + (menuActive ? "active" : "")}>
                <div className="sticky-header main-bar-wraper navbar-expand-lg">
                    <div className="main-bar">
                        <div className="container-fluid clearfix">
                            <div className="logo-header">
                                <div className="logo-header-inner logo-header-one">
                                    <div style={{ minWidth: '200px' }} className="logo-header-inner logo-header-one">
                                        <NavLink to={publicUser.INITIAL}>
                                            <JobZImage src="/images/skins-logo/logo-skin-6.png" alt="Logo" />
                                        </NavLink>
                                    </div>
                                    {/* <NavLink to={publicUser.HOME1}>
                                        {
                                            _config.withBlackLogo
                                                ?
                                                <JobZImage src="images/logo-12.png" alt="" />
                                                :
                                                (
                                                    _config.withWhiteLogo
                                                        ?
                                                        <JobZImage src="images/logo-white.png" alt="" />
                                                        :
                                                        (
                                                            _config.withLightLogo ?
                                                                <>
                                                                    <JobZImage id="skin_header_logo_light" src="images/logo-light-3.png" alt="" className="default-scroll-show" />
                                                                    <JobZImage id="skin_header_logo" src="images/logo-dark.png" alt="" className="on-scroll-show" />
                                                                </> :
                                                                <JobZImage id="skin_header_logo" src="images/logo-dark.png" alt="Logo" />
                                                        )
                                                )
                                        }
                                    </NavLink> */}
                                </div>
                            </div>
                            {/* NAV Toggle Button */}
                            <button id="mobile-side-drawer"
                                data-target=".header-nav"
                                data-toggle="collapse"
                                type="button"
                                className="navbar-toggler collapsed"
                                onClick={handleNavigationClick}
                            >
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar icon-bar-first" />
                                <span className="icon-bar icon-bar-two" />
                                <span className="icon-bar icon-bar-three" />
                            </button>
                            {/* MAIN Vav */}
                            <div className="nav-animation header-nav navbar-collapse collapse d-flex justify-content-center">
                                <ul className=" nav navbar-nav">
                                    <li className="has-mega-menu"><a href="/index">{t("Home")}</a>
                                        <ul className="mega-menu">
                                            {/* <li>
                                                <ul>
                                                    <li><NavLink to={publicUser.HOME1}>Home-1</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME2}>Home-2</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME3}>Home-3</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME4}>Home-4</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME5}>Home-5</NavLink></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <ul>
                                                    <li><NavLink to={publicUser.HOME6}>Home-6</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME7}>Home-7</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME8}>Home-8</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME9}>Home-9</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME10}>Home-10</NavLink></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <ul>
                                                    <li><NavLink to={publicUser.HOME11}>Home-11</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME12}>Home-12</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME13}>Home-13</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME14}>Home-14</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME15}>Home-15</NavLink></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <ul>
                                                    <li><NavLink to={publicUser.HOME16}>Home-16</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME17}>Home-17</NavLink></li>
                                                    <li><NavLink to={publicUser.HOME18}>Home-18</NavLink></li>
                                                </ul>
                                            </li>*/}
                                        </ul>
                                    </li>
                                    {/* <li className="has-child"><a href="#">Jobs</a>
                                        <ul className="sub-menu">
                                            <li><NavLink to={publicUser.jobs.GRID}>Jobs Grid</NavLink></li>
                                            <li><NavLink to={publicUser.jobs.GRID_MAP}>Jobs Grid with Map</NavLink></li>
                                            <li><NavLink to={publicUser.jobs.LIST}>Jobs List</NavLink></li>
                                            <li className="has-child"><a href="#">Job Detail</a>
                                                <ul className="sub-menu">
                                                    <li><NavLink to={publicUser.jobs.DETAIL1}>Detail 1</NavLink>
                                                    </li><li><NavLink to={publicUser.jobs.DETAIL2}>Detail 2 </NavLink>
                                                    </li></ul>
                                            </li>
                                            <li><NavLink to={publicUser.jobs.APPLY}>Apply Jobs</NavLink></li>
                                        </ul>
                                    </li> */}
                                    <li className="has-child"><a href="/employers">{t("Employers")}</a>
                                        {/* <ul className="sub-menu">
                                            <li><NavLink to={publicUser.employer.GRID}>Employers Grid</NavLink></li>
                                            <li><NavLink to={publicUser.employer.LIST}>Employers List</NavLink></li>
                                            <li className="has-child"><a href="#">Employers Detail</a>
                                                <ul className="sub-menu">
                                                    <li><NavLink to={publicUser.employer.DETAIL1}>Detail 1</NavLink>
                                                    </li><li><NavLink to={publicUser.employer.DETAIL2}>Detail 2</NavLink>
                                                    </li></ul>
                                            </li>
                                        </ul> */}
                                    </li>
                                    <li className="has-child"><a href="/candidates">{t("Workers")}</a>
                                        {/* <ul className="sub-menu">
                                            <li><NavLink to={publicUser.candidate.GRID}>Candidates Grid</NavLink></li>
                                            <li><NavLink to={publicUser.candidate.LIST}>Candidates List</NavLink></li>
                                            <li className="has-child"><a href="#">Candidate Detail</a>
                                                <ul className="sub-menu">
                                                    <li><NavLink to={publicUser.candidate.DETAIL1}>Detail 1</NavLink>
                                                    </li><li><NavLink to={publicUser.candidate.DETAIL2}>Detail 2</NavLink>
                                                    </li></ul>
                                            </li>
                                        </ul> */}
                                    </li>
                                    {/* <li className="has-child"><a href="/blog-list">{t("Blog")}</a> */}
                                    {/* <ul className="sub-menu">
                                            <li><NavLink to={publicUser.blog.GRID1}>Blog</NavLink></li>
                                            <li><NavLink to={publicUser.blog.GRID2}>Blog Grid</NavLink></li>
                                            <li><NavLink to={publicUser.blog.GRID3}>Blog Grid-2</NavLink></li>
                                            <li><NavLink to={publicUser.blog.LIST}>Blog List</NavLink></li>
                                            <li><NavLink to={publicUser.blog.DETAIL}>Blog Detail</NavLink></li>
                                        </ul> */}
                                    {/* </li> */}
                                    {/* <li className="has-child"><a href="#">Pages</a>
                                        <ul className="sub-menu"> */}
                                    <li className="has-child"><a href="/about-us">{t("About Us")}</a></li>
                                    {/* <li><NavLink to={publicUser.pages.PRICING}>Pricing</NavLink></li>
                                            <li><NavLink to={publicUser.pages.ERROR404}>Error-404</NavLink></li>
                                            <li><NavLink to={publicUser.pages.FAQ}>FAQ's</NavLink></li>
                                            <li><NavLink to={publicUser.pages.CONTACT}>Contact Us</NavLink></li>
                                            <li><NavLink to={publicUser.pages.MAINTENANCE}>Under Maintenance</NavLink></li>
                                            <li><NavLink to={publicUser.pages.COMING}>Coming soon</NavLink></li>
                                            <li><NavLink to={publicUser.pages.LOGIN}>Login</NavLink></li>
                                            <li><NavLink to={publicUser.pages.AFTER_LOGIN}>After Login</NavLink></li>
                                            <li><NavLink to={publicUser.pages.ICONS}>Icons</NavLink></li> */}
                                    {/* </ul>
                                    </li> */}
                                    <li className="has-child"><a href="/pricing">{t("Pricing")}</a></li>
                                    <div style={{ marginTop: '10px', marginLeft: '40px' }} className="header-lang-selector">
                                        <LanguageSelector />
                                    </div>
                                    <div className="dashboard-user-section d-flex align-items-center gap-3">
                                        {user ? (
                                            <div className="listing-user">
                                                <div className="dropdown">
                                                    <a className="dropdown-toggle" id="ID-ACCOUNT_dropdown" data-bs-toggle="dropdown">
                                                        <div className="user-name text-black d-flex align-items-center gap-2">
                                                            <span>
                                                                {user.photo_url && !imgError ? (
                                                                    <img
                                                                        src={user.photo_url}
                                                                        alt="Profile"
                                                                        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                                        className="rounded-circle"
                                                                        onError={() => setImgError(true)}
                                                                    />
                                                                ) : (

                                                                    <div
                                                                        className="rounded-circle"
                                                                        style={{
                                                                            color: '#fff',
                                                                            width: '40px',
                                                                            height: '40px',
                                                                            objectFit: 'cover',
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontWeight: "500",
                                                                            fontSize: "22px",
                                                                            backgroundColor: getAvatarColor()
                                                                        }}
                                                                    >
                                                                        {getInitials()}
                                                                    </div>
                                                                    // <JobZImage
                                                                    //     src="images/user-avtar/pic4.jpg"
                                                                    //     alt="Profile"
                                                                    //     className="rounded-circle"
                                                                    //     style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                                    // />
                                                                )}
                                                            </span>
                                                            {`${user.first_name} ${user.last_name}`}
                                                        </div>
                                                    </a>
                                                    <div style={{ padding: '15px' }} className="dropdown-menu" aria-labelledby="ID-ACCOUNT_dropdown">
                                                        <ul>
                                                            <li><NavLink to={canRoute(candidate.DASHBOARD)}><i className="fa fa-home" /> {t("Dashboard")}</NavLink></li>
                                                            <li><NavLink to={canRoute(candidate.PROFILE)}><i className="fa fa-user" /> {t("Profile")}</NavLink></li>
                                                            <li><a data-bs-toggle="modal" data-bs-target="#logout-dash-profile"><i className="fa fa-share-square" /> {t("Logout")}</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="extra-nav header-2-nav">
                                                <div className="extra-cell">
                                                    <div className="header-nav-btn-section d-flex">
                                                        <div className="twm-nav-btn-left">
                                                            <NavLink className="twm-nav-sign-up" to={publicUser.pages.REGISTER}>
                                                                {/* <i className="feather-log-in" />  */}
                                                                {t("Sign Up")}
                                                            </NavLink>
                                                        </div>
                                                        <div className="twm-nav-btn-right">
                                                            <NavLink className="twm-nav-post-a-job" to={publicUser.pages.LOGIN}>
                                                                {/* <i className="feather-log-in" />  */}
                                                                {t("Sign In")}
                                                            </NavLink>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </ul>
                            </div>
                            {/* Header Right Section*/}
                            <div className="extra-nav header-2-nav">
                                {/* <div className="extra-cell">
                                    <div className="header-search">
                                        <a href="#search" className="header-search-icon"><i className="feather-search" /></a>
                                    </div>
                                </div> */}
                                {/* <div className="extra-cell">
                                    <div className="header-nav-btn-section">
                                        <div className="twm-nav-btn-left">
                                            <a className="twm-nav-sign-up" data-bs-toggle="modal" href="#sign_up_popup" role="button">
                                                <i className="feather-log-in" /> Sign Upwdwd
                                            </a>
                                        </div>
                                        <div className="twm-nav-btn-right">
                                            <a className="twm-nav-post-a-job" data-bs-toggle="modal" href="#sign_up_popup2" role="button">
                                                <i className="feather-log-in" /> Sign In
                                            </a>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <li className="header-widget"> */}

                                {/* </li> */}
                            </div>
                        </div>
                    </div>
                    {/* SITE Search */}
                    <div id="search">
                        <span className="close" />
                        <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
                            <input className="form-control" name="q" type="search" placeholder="Type to search" />
                            <span className="input-group-append">
                                <button type="button" className="search-btn">
                                    <i className="fa fa-paper-plane" />
                                </button>
                            </span>
                        </form>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header1;